// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const RatingStarSvg = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 31"
    role="presentation"
  >
    <rect width="30px" height="30px" y="0.5" fill={color} rx="15" />
    <path
      fill="#FCFBFC"
      d="M15 19.8L9.8 22.5 10.8 16.7 6.6 12.6 12.4 11.8 15 6.5 17.6 11.8 23.4 12.6 19.2 16.7 20.2 22.5z"
    />
  </svg>
);
RatingStarSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default RatingStarSvg;
